import axios from 'axios'
import React from 'react'

import './css/PageNotFound.css'
import InviteForm from './InviteForm'
import PageNotFoundText from './text/page-not-found-text'

export const toJSONLocal = (date) => {
  var local = new Date(date);
  local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
  return local.toJSON().slice(0, 10);
}

export default class PageNotFound extends React.Component {
  componentWillMount() {
    axios.post('/error', {
      error: `Redirected to 404 page at ${toJSONLocal(new Date())}`
    })
  }

  render() {
    return (
      <div className="page-not-found-container">
        <div className="pnf-header">{PageNotFoundText[0]}</div>
        <div className="section">
          <div className="pnf-subheader">{PageNotFoundText[1]}</div>
          <div className="pnf-subheader">{PageNotFoundText[2]}</div>
        </div>
        <div className="small-text">{PageNotFoundText[3]}</div>
        <div className="section">
          <div className="pnf-small-header">
            <a href="https://hbr.org/2016/03/learning-to-learn">
              {PageNotFoundText[4]}
            </a>
          </div>
        </div>
        <div className="section two">
          <div className="left">
            <div className="small-text">{PageNotFoundText[5]}</div>
            <div className="small-text">{PageNotFoundText[6]}</div>
            <InviteForm />
          </div>
          <div className="right">
            <div className="section">
              <div className="small-text">{PageNotFoundText[7]}</div>
            </div>
            <div className="section block">
              <div className="inline">
                <div className="small-text inline">{PageNotFoundText[8]}</div>
                <a className="small-text" href="">{PageNotFoundText[9]}</a>
              </div>
              <div>
                <div className="small-text inline">{PageNotFoundText[10]}</div>
                <a className="small-text" href="">{PageNotFoundText[11]}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/PageNotFound.js